document.addEventListener("DOMContentLoaded", function () {
  console.log("DOM fully loaded and parsed");

  // Initialize Swiper if present
  if (document.querySelector(".addon-swiper")) {
    console.log("Initializing Swiper...");
    new Swiper(".addon-swiper", {
      slidesPerView: "auto",
      spaceBetween: 10,
      freeMode: true,
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
      },
    });
  }

  // Handle each addon selector block
  const addonBlocks = document.querySelectorAll(".addon-selector-block");
  console.log("Found addon blocks:", addonBlocks.length);

  addonBlocks.forEach((block, blockIndex) => {
    const showVariants = block.dataset.showVariants === "true";
    const thumbs = block.querySelectorAll(".addon-product-thumb");
    const variantGroups = block.querySelectorAll(".variant-group");
    const display = block.querySelector(".selected-addon-display");
    const hiddenInput = block.querySelector(".selected-addon-id");

    console.log(`Processing addon block #${blockIndex + 1}`);

    // Quantity buttons
    block.querySelectorAll(".increase").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.stopPropagation();
        const input = btn.closest(".qty-selector").querySelector("input");
        input.value = parseInt(input.value || 0) + 1;
        console.log("Increased qty:", input.value);
      });
    });

    block.querySelectorAll(".decrease").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.stopPropagation();
        const input = btn.closest(".qty-selector").querySelector("input");
        const val = parseInt(input.value || 0);
        input.value = val > 0 ? val - 1 : 0;
        console.log("Decreased qty:", input.value);
      });
    });

    // Thumbnail selection
    thumbs.forEach((thumb, index) => {
      thumb.addEventListener("click", () => {
        thumbs.forEach((t) => t.classList.remove("selected"));
        thumb.classList.add("selected");

        const title = thumb.dataset.title;
        const price = thumb.dataset.price;
        display.textContent = `| ${title} (${price})`;

        console.log(`Selected addon: ${title} - ${price}`);

        if (showVariants) {
          block.classList.add("active");
          variantGroups.forEach((group, i) => {
            const isActiveGroup = i === index;
            group.classList.toggle("active", isActiveGroup);
            if (!isActiveGroup) {
              group.querySelectorAll("input").forEach((input) => {
                input.value = 0;
              });
            }
          });
        }

        hiddenInput.value = thumb.dataset.id;
        console.log("Hidden input set to:", hiddenInput.value);
      });
    });
  });

  // Main product-form integration (addons only)
  const productForm = document.querySelector("product-form form");

  if (productForm) {
    console.log("Product form found");

    productForm.addEventListener("submit", function (e) {
      e.preventDefault();

      const submitBtn = productForm.querySelector('button[type="submit"]');
      submitBtn.disabled = true;
      productForm.classList.add("is-loading");

      const items = []; // no main product

      document.querySelectorAll(".addon-selector-block").forEach((block, index) => {
        const showVariants = block.dataset.showVariants === "true";
        let variantAdded = false;

        // Add variants if selected
        block.querySelectorAll(".variant-row").forEach((row) => {
          const input = row.querySelector("input");
          const qty = parseInt(input?.value || 0);
          if (qty > 0) {
            const variantId = row.dataset.variantId;
            items.push({ id: variantId, quantity: qty });
            variantAdded = true;
            console.log("Added variant:", { id: variantId, quantity: qty });
          }
        });

        // Add base addon if no variant was selected
        const addonId = block.querySelector(".selected-addon-id")?.value;
        if (!variantAdded && addonId) {
          items.push({ id: addonId, quantity: 1 });
          console.log("Fallback addon added:", addonId);
        }
      });

      console.log("Final addon items to send:", items);

      if (items.length === 0) {
        console.warn("No addons selected");
        showFormError("Please select at least one addon before continuing.");
        submitBtn.disabled = false;
        productForm.classList.remove("is-loading");
        return;
      }

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items }),
      })
        .then((res) => {
          if (res.ok) {
            console.log("Addons added to cart successfully");
            // window.location.href = "/cart";
          } else {
            console.error("Add to cart failed", res);
            showFormError("There was a problem adding addons to your cart.");
          }
        })
        .catch((err) => {
          console.error("Error adding addons:", err);
          showFormError("Something went wrong. Please try again.");
        })
        .finally(() => {
          submitBtn.disabled = false;
          productForm.classList.remove("is-loading");
        });
    });
  } else {
    console.warn("Product form not found");
  }

  // Error display utility
  function showFormError(message) {
    const errorWrapper = document.querySelector(".product-form__error-message-wrapper");
    const errorMessage = document.querySelector(".product-form__error-message");

    if (errorWrapper && errorMessage) {
      errorWrapper.hidden = false;
      errorMessage.textContent = message;
    }
  }
});
